<template>
  <div class="nav-bar">
    <div id="nav">
      <div id="routes" class="nav-links">
        <router-link to="/statisztika"><v-icon name="chart-bar"/> Epidemiológiai adatok</router-link>
        <router-link to="/lekerdezes"><v-icon name="users"/> Regiszterben lévő adatok</router-link>
        <router-link to="/tomeges-feltoltes"><v-icon name="file"/> Tömeges feltöltés fájlból</router-link>
        <router-link to="/bekuldes"><v-icon name="pen"/> Egyedi feltöltés űrlapon keresztül</router-link>
      </div>
      <div id="user" class="nav-links">
        <router-link v-if="Boolean(this.getUser)" to="/elfelejtett-jelszo">Jelszóváltoztatás</router-link>
        <a v-if="Boolean(this.getUser)" @click="signOut()" class="float-right"><v-icon name="sign-out-alt"/> Kilépés</a>      
        <router-link v-else to="/belepes" class="float-right"><v-icon name="sign-in-alt"/> Belépés</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-awesome/icons/chart-bar'
import 'vue-awesome/icons/users'
import 'vue-awesome/icons/file'
import 'vue-awesome/icons/pen'
import 'vue-awesome/icons/sign-in-alt'
import 'vue-awesome/icons/sign-out-alt'
import Icon from 'vue-awesome/components/Icon'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'nav-bar',
  components: {
    'v-icon': Icon
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  methods: {
    ...mapActions(['signUserOut']),
    signOut() {
      this.signUserOut()
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
/*** Component Style ***/
.nav-bar {
  position: relative;
  text-align: left;
  box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.25);
  margin-bottom: 32px;

  #nav {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: baseline;
    padding-left: 30px;
    padding-right: 30px;
      
    .nav-links {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }

    #routes {
      order: 2
    }

    #user {
      order: 1
    }

    a {
      font-weight: bold;
      height: 30px;
      color: #2c3e50;
      margin-left: 32px;
      margin-right: 32px;
      display: inline-flex;
      margin-top: 17px;
      margin-bottom: 17px;
      align-items: center;

      svg {
        margin-top: auto;
        margin-bottom: auto;
        margin-right: 6px;
      }
      
      &.router-link-exact-active {
        color: #fe6f2b;
      }
    }
    a:hover {
      cursor: pointer;
      text-decoration-line: underline;
    }
  }
}
</style>